import * as actionTypes from './Actions_name'; // IMPORTA LE COSTANTI ACTIONS

// Per eseguire delle chiamate asyncrone
import axios from 'axios';

// Si utilizza per settare ad esempio lo stato ad un loading
export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = (idToken, userId) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: idToken,
        userId: userId
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = () => {
    // console.log("[ACTION] - Action Logout!");

    // rimuovi i dati quindi anche dal localstorage quando si effettua il Logout
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');

    return {
        type: actionTypes.AUTH_LOGOUT,
        token: null,
        userId: null
    }
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        // crea un timer che dura esattamente la durata del token (quanto tempo è valido) ed esegui il logout
        setTimeout(() => {
            dispatch(logout()); // chiama la funzione logout in async
        }, expirationTime * 1000); // 3600 * 1000 millisecondi quindi un ora
    };
};

// Verifica lo stato del login al momento del refresh della pagina ad esempio
export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (!token) {
            // se non esiste un token salvato in localStorage resetta tutto ed effettua il logout
            dispatch(logout());
        } else {
            // nel caso il token esista
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(logout("Token Expired!"));
            } else {
                const userId = localStorage.getItem('userId');
                dispatch(authSuccess(token, userId)); // imposta come success e passa quindi i dati come ad esempio l'id dell'utente
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000)); // passa al timer quindi quanto manca alla scadenza del token
            }
        }
    };
};

export const auth = (email, password) => {
    return dispatch => {
        // qui effettuo l'autenticazione dell'utente
        dispatch(authStart());

        // console.log(email, password);
        // Axios Request to Beckend
        // di solito axios trasforma l'oggetto già in un json
        const data_send = { // Con axios invia automaticamente i dati in formato JSON al server non cè bisogno di usare => JSON.stringify()
            user: email,
            pass: password
        };
        axios.post('https://www.tuunes.co/notification/requestLogin', data_send)
            .then(response => {
                //console.log(response);
                let data = response.data;
                // console.log("AXIOS: ", data);
                if (data.error === false) {
                    // console.log("SUCCESS");

                    // SALVO IL TOKEN NEL LOCALSTORAGE IN MODO DA SALVARE I DATI IN CASO DI REFRESH PAGE
                    const expirationDate = new Date(new Date().getTime() + response.data.expiredTime * 1000); // calcolo la data di scadenza del token (aggiungo 3600 che sarebbe il tempo di validità) * 1000 per convertire millisecondi in secondi => 1 Ora
                    localStorage.setItem('token', response.data.token); // salvo il token nel LocalStorage
                    localStorage.setItem('expirationDate', expirationDate); // salvo anche la data di scadenza del token quindi
                    localStorage.setItem('userId', "iduserTest01"); // salva anche l'user ID

                    dispatch(authSuccess(response.data.token, "iduserTest01"));
                    // request function async
                    dispatch(checkAuthTimeout(response.data.expiredTime));
                } else {
                    //console.log("ERROR");
                    dispatch(authFail("Username or Password wrong.")); // imposto il messaggio d'errore
                }
            })
            .catch(error => {
                //console.log("CATCH ERROR LOADINGHandler: ", error);
                if (!error.response) {
                    //console.log('NO CONNECTION - Error:Network Error!!!');
                    dispatch(authFail('NO CONNECTION - Error:Network Error!!!'));
                } else {
                    // console.log("Altro tipo di errore Nella REQUEST", error.respose.data.message);
                    dispatch(authFail(error.respose.data.message));
                }

            });


    };
};